/**
 * cruise-map-preview-widget — public entry. ES-module importable (public_api_v3.md §3):
 *
 *   import { createVoyagePreview } from "cruise-map-preview-widget";
 *
 * The built IIFE bundle (dist/<version>/widget.js) exposes the same factory as
 * window.PreviewEmbed.createVoyagePreview for <script>-tag consumers (the Shopify path).
 */
export { createVoyagePreview } from "./preview.js";
export { DEFAULTS } from "./defaults.js";
